import React, { useState, Fragment } from 'react';
import styled from 'styled-components';
import MenuCart from './MenuCart';

const StyledBurger = styled.div`
  width: 2rem;
  height: 1.3rem;
  position: relative;
  // top: 1.7rem;
  cursor: pointer;
  // right: 1.6rem;
  // border: 1px solid red;
  display: flex;
  justify-content: space-between;
  flex-flow: column nowrap;
  z-index: 99999;

  div {
    width: 1.8rem;
    height: 0.15rem;
    background-color: ${({ open }) => (open ? '#000' : '#fff')};
    border-radius: 3px;
    transform-origin: 1px;
    transition: all 0.5s linear;

    &:nth-child(1) {
      transform: ${({ open }) => (open ? 'rotate(39deg)' : 'rotate(0)')};
    }

    &:nth-child(2) {
      transform: ${({ open }) => (open ? 'rotate(-39deg)' : 'rotate(0)')};
    }
  }
`;
const BurgerMenu = () => {
  const [open, setOpen] = useState(false);
  return (
    <Fragment>
      <StyledBurger open={open} onClick={() => setOpen(!open)}>
        <div />
        <div />
      </StyledBurger>
      <MenuCart open={open} />
    </Fragment>
  );
};

export default BurgerMenu;
